<template>
  <v-menu offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <Button color="secondary" overlay size="small" icon="gear" v-bind="attrs" v-on="on">
        {{ $t('Settings') }}
      </Button>
    </template>
    <DropdownMenu>
      <DropdownMenuElement @click.native="openProjectSettings">
        {{ $t('Project settings') }}
      </DropdownMenuElement>
      <DropdownMenuElement v-if="project.status === 'archived'" @click.native="unarchiveProject">
        {{ $t('Unarchive project') }}
      </DropdownMenuElement>
      <DropdownMenuElement v-else @click.native="archiveProject">
        {{ $t('Archive project') }}
      </DropdownMenuElement>
    </DropdownMenu>
  </v-menu>
</template>

<script>
  import { mapActions } from 'vuex';
  import ProjectSettingsModal from '@/containers/top-menu/header/project-settings/Modal';
  import request from '@/utils/api/request';
  import Button from '@/components/ui/Button';
  import { VMenu } from 'vuetify/lib';
  import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';

  export default {
    name: 'SettingsDropdown',
    components: { DropdownMenuElement, DropdownMenu, Button, VMenu },
    props: {
      project: {
        type: Object,
        default: null,
      },
      navigateAfterAction: {
        type: Boolean,
        default: true,
      },
      showTriggerText: {
        type: Boolean,
        default: true,
      },
      isWhite: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
        confirm: 'confirmModal/openModal',
        closeModal: 'modal/closeModal',
        setModalError: 'modal/setModalError',
      }),
      openProjectSettings() {
        this.openModal({
          component: ProjectSettingsModal,
          context: {
            createForm: false,
            projectId: this.project?.id,
            attributes: {
              class: 'create-tender__container',
            },
            update: () => {
              this.$emit('deleteProject');
            },
          },
        });
      },
      archiveProject() {
        this.confirm({
          title: this.$t('Archive project'),
          description: `${this.$t('Are you sure you want to archive project')} ${
            this.project.name
          }?`,
          actionText: this.$t('Archive'),
          notCloseAfterAction: true,
          action: async () => {
            try {
              await request.post(`/projects/${this.project.id}/archive/`);
              this.$emit('refresh');
              if (this.navigateAfterAction) {
                await this.$router.push({ name: 'projects' });
              }
              this.closeModal();
            } catch (e) {
              // eslint-disable-next-line
              console.error(e);
              this.setModalError({ error: e.response.data });
            }
          },
        });
      },
      unarchiveProject() {
        this.confirm({
          title: this.$t('Unarchive project'),
          description: `${this.$t('Are you sure you want to unarchive project')} ${
            this.project.name
          }?`,
          actionText: this.$t('Unarchive'),
          notCloseAfterAction: true,
          action: async () => {
            try {
              await request.post(`/projects/${this.project.id}/unarchive/`);
              this.$emit('refresh');
              this.closeModal();
            } catch (e) {
              // eslint-disable-next-line
              console.error(e);
              this.setModalError({ error: e.response.data });
            }
          },
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .settings {
    margin-right: 8px;
    margin-left: 8px;
  }
</style>
